<template>
	<b-modal id="zone-violation-report-modal" ref="zoneViolationModalRef" title="Critical Zone Violation Report" class="" :class="" centered size="lg">

		<div class="table-wrapper">
			<table class="table table-striped table-hover">
				<thead>
				<tr>
					<th>#</th>
					<th>Asset Name</th>
					<th>Zone Name</th>
					<th>Entry Time</th>
					<th>Exit Time</th>
					<th>Entry Duration</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item, key, index) in entries">
					<td>{{index+1}}</td>
					<td>{{item.worker.first_name+' '+item.worker.last_name}}</td>
					<td>{{ $zone.get(item.zone_id).name }}</td>
					<td>{{$datetime.datetime(item.time, item.day)}}</td>
					<td>{{ Object.keys(item.exit).length ? $datetime.datetime(item.exit.time, item.day) : '' }}</td>
					<!--<td>{{ moment.utc((item.end - item.time)*1000).format('HH:mm:ss') }}</td>-->
					<td>{{ Object.keys(item.exit).length ? moment.utc(( (item.exit.time * (item.day - item.day + 1) ) - item.time)*1000).format('HH:mm:ss') : moment.utc((time - item.time)*1000).format('HH:mm:ss') }}</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div slot="modal-footer">
			<b-btn type="button" class="btn btn-dark pl-4 pr-4" @click="$refs.zoneViolationModalRef.hide()">Close</b-btn>
		</div>

	</b-modal>
</template>
<script>
	export default {
		name: 'ZoneViolationReport',
		computed: {
			alert() { return this.$store.state.alert },
			time() { return this.$store.state.time },
			entries() {
				return this.$finder.all({type: 'entry'}, this.alert)
			}
		}
	}
</script>
